import { Bot, Globe, Smartphone, TrendingUp, type LucideIcon } from "lucide-react";

import type { ServiceLine } from "@/features/projects/api";
import { cn } from "@/shared/lib/cn";

const ICONS: Record<ServiceLine, LucideIcon> = {
  web: Globe,
  mobile: Smartphone,
  automation: Bot,
  marketing: TrendingUp,
};

/* Colours come from the design tokens (--color-service-*). */
const TILE: Record<ServiceLine, string> = {
  web: "bg-service-web-soft text-service-web",
  mobile: "bg-service-mobile-soft text-service-mobile",
  automation: "bg-service-automation-soft text-service-automation",
  marketing: "bg-service-marketing-soft text-service-marketing",
};

export function ServiceIcon({ service, className }: { service: ServiceLine; className?: string }) {
  const Icon = ICONS[service];
  return <Icon className={className} aria-hidden="true" />;
}

/** The service icon on its colour tile: how a project is recognised at a glance. */
export function ServiceTile({
  service,
  size = "md",
}: {
  service: ServiceLine;
  size?: "sm" | "md" | "lg";
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "grid shrink-0 place-items-center",
        TILE[service],
        size === "sm" && "size-5 rounded-[5px] [&_svg]:size-3",
        size === "md" && "size-8 rounded-lg [&_svg]:size-4",
        size === "lg" && "size-10 rounded-[10px] [&_svg]:size-5",
      )}
    >
      <ServiceIcon service={service} />
    </span>
  );
}
